import axios from 'axios';
import store from '../store';

const myFetchFactory = store => configuration => {
  const token = store.getState().user.token;
  const headers = {
    Authorization: `Bearer ${token}`
  };

  const newConfiguration = {
    ...configuration,
    headers
  };

  return axios(newConfiguration);
};

const myFetch = myFetchFactory(store);

export default myFetch;



// WEBPACK FOOTER //
// ./src/utils/myFetch.js